<template>
  <WizardLayout>
    <template #title>Tell us about you</template>

    <div class="d-flex flex-column">
      <v-form ref="form" @submit.prevent="onSubmit">
        <div 
          class="ma-2 py-4 px-3 white rounded d-flex flex-column"
          style="gap: 12px;"
        >
          <div style="line-height: 1.2">
            We need to let the pros know how to reach you.  Your information will
            only be shared with four pros.
          </div>

          <v-text-field
            dense outlined validate-on-blur hide-details="auto"
            v-model="name"
            label="Name"
            :rules="[required]"
          />

          <div class="d-flex" style="column-gap: 12px;">
            <v-text-field
              dense outlined validate-on-blur hide-details="auto"
              v-model="phone"
              label="Phone"
              v-mask="'(###) ###-####'"
              :rules="[required, valid_us_phone]"
            />
            <v-text-field
              dense outlined validate-on-blur hide-details="auto"
              v-model="zipcode"
              label="Zipcode"
              v-mask="'#####'"
              :rules="[required, valid_us_zipcode]"
            />
          </div>

          <v-checkbox 
            dense hide-details="auto"
            class="mt-0"
            v-model="consent"
            :rules="[required]"
          >
            <template #label>
              <span style="font-size: 12px; line-height: 1.1">
                I agree to allow Referra and their selected pros to contact me.
              </span>
            </template>
          </v-checkbox>

          <v-img src="@/assets/wizard/whoareyou.png" />

          <div class="d-flex mt-2" style="gap: 12px;">
            <v-spacer/>
            <v-btn @click="$router.replace({ name: 'wizard/notes' })">Back</v-btn>
            <v-btn type="submit" color="primary">Next</v-btn>
            <v-spacer/>
          </div>
        </div>
      </v-form>

      <WizardOverlay 
        v-model="error_dialog"
        @close="$router.replace({ name: 'link' })"
      />
    </div>
  </WizardLayout>
</template>

<script>
import { WizardLayout } from '@/layouts'
import { WizardOverlay } from '@/components/pages'

import { mapActions, mapGetters } from 'vuex'
import { required, valid_us_phone, valid_us_zipcode } from '@/lib/validations'

export default {
  name: 'QRContactView',

  components: { WizardLayout, WizardOverlay },

  data: () => ({
    loading: false,
    error_dialog: false,

    consent: false,
    name: '',
    phone: '',
    zipcode: '',

    // validations
    required,
    valid_us_phone,
    valid_us_zipcode,
  }),

  computed: {
    ...mapGetters('qr', ['request']),
  },

  methods: {
    ...mapActions('qr', ['missingStageRequirements', 'requestCode', 'setContact']),
  
    async onSubmit() {
      if (this.$refs.form.validate()) {
        const { name, phone, zipcode } = this 

        this.setContact({ name, phone, zipcode })

        
        const result = await this.requestCode({ phone })
        if (result.ok) {
          this.$router.replace({ name: 'wizard/verify' })
        }
      }
    },
  },

  async created() {
    const result = await this.missingStageRequirements(4)
    if (result) {
      this.error_dialog = true
    }
  },
}
</script>